export const CUSTOMER_EXISTS = 'CustomerExists';
export const INVALID_EMAIL = 'InvalidEmail';
